module.exports = __webpack_public_path__ + "img/default.fe37fb05.svg";